import React, { type ReactNode, createContext, useContext } from 'react';
import noop from 'lodash/noop';

export const BoardVirtualizationContext = createContext({
	onBoardCardResize: noop,
});

type Props = {
	onBoardCardResize: () => void;
	children: ReactNode;
};

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const BoardVirtualizationProvider = ({ children, onBoardCardResize }: Props) => (
	<BoardVirtualizationContext.Provider value={{ onBoardCardResize }}>
		{children}
	</BoardVirtualizationContext.Provider>
);

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const useBoardVirtualization = () => useContext(BoardVirtualizationContext);
